// features/guest/guestSlice.js
import { createSlice } from "@reduxjs/toolkit";

const guestSlice = createSlice({
  name: "guest",
  initialState: {
    accessAttemptId: 0, // 👈 number instead of boolean
  },
  reducers: {
    guestAccessAttempt(state) {
      state.accessAttemptId += 1;
    },
  },
});

export const { guestAccessAttempt } = guestSlice.actions;
export default guestSlice.reducer;





// import { createSlice } from "@reduxjs/toolkit";

// const guestSlice = createSlice({
//   name: "guest",
//   initialState: {
//     guestAccessMessage: false,
//   },
//   reducers: {
//     showGuestAccessMessage(state) {
//       state.guestAccessMessage = true;
//     },
//     hideGuestAccessMessage(state) {
//       state.guestAccessMessage = false;
//     },
//   },
// });

// export const {
//   showGuestAccessMessage,
//   hideGuestAccessMessage,
// } = guestSlice.actions;

// export default guestSlice.reducer;
